function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.306 34.319C8.131 33.186 1 30.199 1 26.694c0-4.48 11.864-8.113 26.5-8.113S54 22.213 54 26.694c0 3.471-7.124 6.434-17.141 7.591"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.163 29.939c4.068-2.88 13.434-4.867 24.337-4.867 10.947 0 20.296 1.968 24.337 4.867m2.164-3.245c-.048 2.1 0 5.36 0 6.49 0 1.832-1.984 3.522-5.33 4.88M18.307 40.8C8.187 39.657 1 36.679 1 33.184v-6.49"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.694 39.155v2.681A2.159 2.159 0 0134.531 44H20.47a2.159 2.159 0 01-2.164-2.164v-7.571c0-1.198.965-2.163 2.164-2.163h14.06c1.2 0 2.164.965 2.164 2.163v2.683"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.531 39.673a2.159 2.159 0 01-2.163 2.163h-9.735a2.159 2.159 0 01-2.163-2.163v-3.245c0-1.198.965-2.163 2.163-2.163h9.735c1.198 0 2.163.965 2.163 2.163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.122 36.969h9.735c.599 0 1.081.482 1.081 1.082s-.482 1.081-1.081 1.081h-9.735c-.6 0-1.082-.482-1.082-1.081s.483-1.082 1.082-1.082z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.98,
  cy: 36.753,
  r: 1.082
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.139,
  cy: 35.455,
  r: 1.082
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.859 34.286l11.733-1.102v6.49l-11.898 1.081"
}));

var SvgBelt = function SvgBelt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBelt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Belt.437a14ed.svg";
export { ForwardRef as ReactComponent };